import animateOnScroll from "./animateOnScroll"
import MiniMasonry from "minimasonry";
import Plyr from 'plyr';
const CONTAINER = ".posts-container";

function initMasonry() {
	const el = document.querySelector(CONTAINER);
	if (!el) return null;
	return new MiniMasonry({
		container: el,
		baseWidth: 290,
		gutter: 20,
        ultimateGutter: 20,
        minify: true
	});
}

function runWhenReady() {
	const el = document.querySelector(CONTAINER);
	if (!el) return;

	let masonry = initMasonry();
	if (!masonry) return;

	// Reflow when all resources (including videos) have loaded
	function relayout() {
		if (masonry) masonry.layout();
	}

	window.addEventListener("load", relayout);

	// Reflow when each video has dimensions (helps on hard refresh)
	el.querySelectorAll("video").forEach((video) => {
		video.addEventListener("loadedmetadata", relayout);
		video.addEventListener("loadeddata", relayout);
	});

	setTimeout(() => {
		animateOnScrollCUSTOM([{ selector: ".story", offset: 0.25, multiple: true }]);
	}, 300);
}

if (document.querySelector(CONTAINER)) {
	// Already past load (e.g. script at end of body, or cached)
	if (document.readyState === "complete") {
		runWhenReady();
	} else {
		document.addEventListener("DOMContentLoaded", runWhenReady);
	}
}

// Since AOS waits for window.load and minimasonry does too, we need to create our own observer
function animateOnScrollCUSTOM(elements) {
	const callback = (entries) => {
		entries.forEach((entry) => {
			if (entry.isIntersecting) {
				entry.target.classList.add("animate");
			}
		});
	};

	const observer = (threshold) => {
		return new IntersectionObserver(callback, {
			threshold: [threshold],
		});
	};

	elements.forEach((el) => {
		if (document.querySelector(el.selector)) {
			if (el.multiple) {
				document.querySelectorAll(el.selector).forEach((multiple) => {
					observer(el.offset).observe(multiple);
				});
			} else {
				observer(el.offset).observe(document.querySelector(el.selector));
			}
		}
	});
}

//animate elements
/*---------------
Notes
-----------------
Offset:
- .5 means half of the element is visible before triggering
- 1 means 100% of the element should be visible
- 0 would be if any part of the element is visible 
CSS animations:
- make sure that the transformX/Y is not too large otherwise it will take forever to animate in
*/

animateOnScroll([
    { selector: ".home .problem img", offset: 0.25, multiple: true },
    { selector: ".home .intro .paper-tear .paper img", offset: 0.25, multiple: true },
    { selector: ".highlight-main", offset: 0.25, multiple: true },
    { selector: ".highlight-main-thin", offset: 0.25, multiple: true },
    { selector: ".home .facts .slide-in-up", offset: 0.25, multiple: true },
    { selector: ".news-feature .california-image", offset: 0.25, multiple: false },
    { selector: ".posts-container article .item-inner", offset: 0.25, multiple: true },
    { selector: ".paper-image", offset: 0.25, multiple: false },
]);